import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as eventApi from '../api/EventLog';
import { IEventLogRow } from '../util/DataModelInterface';
import { DataTable } from './DataTable';
import { Spinner } from './Spinner';
import { DateSelector } from './DateSelector';

interface IMessageTableData {
  date: string,
  user: string,
  company: string,
  type: string,
  event: string
}

export const MessageLog = () => {
    const [logData, setLogData] = useState([] as IEventLogRow[]);
    const [logRowData, setLogRowData] = useState([] as IMessageTableData[]);
    const [loading, setLoading] = useState(false);
    const [inputStartValue, setInputStartValue] = useState<string>('');
    const [inputStopValue, setInputStopValue] = useState<string>('');

    const intl = useIntl();

    useEffect(() => {
      setLoading(true);
      eventApi.readMessageLog().then((data: any) => {
          // console.log("Message Log - data", data);
        if (data) {
          setLogData(data);
          setEventTableData(data);
        }
      }).finally(() => {
        setLoading(false);
      });
    }, []);

    useEffect(() => {
      if (inputStopValue) {
        setLoading(true);
        eventApi.readMessageLog(inputStartValue, inputStopValue).then((data: any) => {
          console.log("Message Log - data", data);
          if (data) {
            setLogData(data);
            setEventTableData(data);
          }
        }).finally(() => {
            setLoading(false);
        });
      }
    }, [inputStartValue, inputStopValue]);

    const setEventTableData = (eventLogData: any[]) => {
      let data = [] as IMessageTableData[];
      eventLogData.forEach((r, i) => {
        data[i] = {
          date: r.timestamp ? r.timestamp.replace(/T|[.].+/g, " ") : "",
          user: r.user_name,
          company: r.company,
          type: r.type,
          event: r.event
        };
      });
      setLogRowData(data);
    }

    const toolBar = () => {
      return(
      <div className="toolbar">
        <span className="item-actions ms-auto">
          <button key='toolbarbutton' className="btn btn btn-primary btn-reminder"
            disabled={logData.length === 0}
            onClick={() => eventApi.exportLog("",
                    { header: intl.formatMessage({id: 'messagelog.title'}),
                      data: logData})}>
            <i className="me-2 fa fa-download" aria-hidden="true"></i>
            <FormattedMessage id={'button.report.download'}/>
          </button>
        </span>
      </div>);
    }

    return (
      <>
        <Spinner active={loading} />
        <div className="d-flex flex-md-row flex-column">
            <div id="history" className="flex-fill">
              <h1><FormattedMessage id={'messagelog.title'}/></h1>
              <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id="messagelog.title.info"/></p>

              <DateSelector
                startPeriod={inputStartValue}
                endPeriod={inputStopValue}
                isStartAndEnd={true}
                onChange={(start, end) => { setInputStartValue(start); setInputStopValue(end);}}
                showMonth={false}
                dateFormat='yyyy-MM-dd'
                inputFormat='y-MM-dd'/>

              <DataTable
                tableheadings={['date', 'user', 'company', 'type', 'event']}
                tabledata={logRowData} tableType='eventlog' tableId='messagetable'
                toolbar={toolBar()}
                showFilters={true}
              />
            </div>
          </div>
      </>
    );
};